import type { AppContext } from '@/types';
import { getRequest } from '@/utils/api';
import type { LoginInfoResponse } from '@/types/login';

export const fetchLoginInfo = async (appContext: AppContext, language: string) => {
    try {
        const { body } = await getRequest<LoginInfoResponse>({
            appContext,
            endpoint: '/ophalenlogininfo',
            language
        });

        return body;
    } catch (error) {
        console.error('Cannot fetch login info:', { error });

        return null;
    }
};
